// ICUMS / UniPass Ghana "Used Vehicle Duty Calculator" (public search of past assessments).
export const UNIPASS_TOOL_URL =
  "https://external.unipassghana.com/cl/tm/tax/selectUsedVehicleTaxCalculate.do?decorator=popup&MENU_ID=IIM01S03V02";

/** Only ever frame / link to the official UniPass host. */
export function isUnipassUrl(raw: string): boolean {
  try {
    const u = new URL(raw);
    return (
      u.protocol === "https:" && u.hostname === "external.unipassghana.com"
    );
  } catch {
    return false;
  }
}
